import styled from "styled-components";

import { Modal as ModalBase, Text } from "/component/base";

export const Body = styled.div(() => ({
  padding: "32px 24px",
}));

export const Content = styled.div({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
});

export const IconContainer = styled.div(({ theme }) => ({
  padding: "2px",
  color: theme.colors.brandCoral,
  alignSelf: "center",
  svg: {
    height: "28px",
    width: "28px",
  },
  marginBottom: "12px",
}));

export const Link = styled.a(({ theme, color = theme.colors.brandActionBlue }) => ({
  width: "fit-content",
  color: color,
  borderBottom: `1px solid ${color}`,
  "&:focus": {
    outline: "none",
  },
}));

export const Modal = styled(ModalBase)(() => ({
  width: "327px",
}));

export const Overlay = styled(ModalBase.Overlay)(() => ({
  backdropFilter: "blur(4px)",
  backgroundColor: "#132A53A6",
}));

export const TextGroup = styled.div({
  marginBottom: "32px",
});

export const Title = styled(Text)({
  fontSize: "18px",
  color: "#1B1B1B",
  marginBottom: "8px",
});
